enum FeatureFlags {
  CART_MAC_MIGRATION_ENABLE_CCP_SEARCH_CALL = 'cart-mac-migration-enable-ccp-search-call',
  MIGRATION_CLOUDS_BANNER_FOR_PARTNERS = 'migration_clouds_baner_for_partners',
  CART_MAINTENANCE_BANNER = 'cart-maintenance-banner',
  CART_LIMIT_DC_MULTI_YEAR_CONTRACTS = 'cart-limit-dc-multi-year-contracts',
  CLOUD_MIGRATION_TRIAL_LINK = 'cloud_migration_trial_cta_enabled',
  CART_CANADA_TAX_EXEMPTIONS_FIELD = 'cart-canada-tax-exemption-field',
  CART_ENABLE_VAT_FOR_SERBIA = 'sc_enable_vat_for_serbia',
  CART_DC_PRODUCT_APP_COUPLING = 'cart-dc-product-app-coupling',
  CART_ENABLE_OMNI_CHANNEL_CHAT = 'cart-enable-omni-channel-chat',
  CART_CD_EOS = 'cart-cd-eos',
  CART_MAPPING_PARENT_APP_CSV = 'cart_mapping-parent-app-csv',
  CART_ENABLE_VAT_FOR_UKRAINE = 'cart-enable-vat-for-ukraine',
  CART_ENABLE_VAT_FOR_UZBEKISTAN = 'cart-enable-vat-for-uzbekistan',
  CART_PRICE_COMPARATOR_EOL = 'cart-price-comparator-eol',
}

export default FeatureFlags;
